import * as React from 'react'


const handleClassLinkClick = (_) => {
  const baseUrl = 'https://launchpad.classlink.com/oauth2/v2/auth'
  const urlEncodedRedirectUrl = encodeURIComponent(`${window.postbuildEnv.DEFAULT_URL}/auth/classlink/callback`)
  const clientId = window.postbuildEnv.CLASSLINK_SSO_CLIENT_ID
  const fullUrl = `${baseUrl}?scope=full&redirect_uri=${urlEncodedRedirectUrl}&client_id=${clientId}&response_type=code`
  window.location.href = fullUrl
}

export const ClasslinkButton = ({isSignUp = false}) => {
  if (!window.postbuildEnv.CLASSLINK_ENABLED) { return <span /> }
  const actionText = isSignUp ? 'Sign up' : 'Log in'

  return (
    <button onClick={handleClassLinkClick} type="button">
      <img
        alt="ClassLink icon"
        className="classlink-icon"
        src={`${window.postbuildEnv.CDN_URL}/images/shared/classlink_icon_sm.png`}
      />
      <span>{actionText} with ClassLink</span>
    </button>
  )
}

export default ClasslinkButton;

